import PinInput from "react-pin-input";
import { Box, Button, Modal, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const DEFAULT_TYPE = {
  EMAIL: {
    title: "Verifica tu correo",
    message: "Enviamos un código a tu correo por favor ingresa el código recibido"
  },
  PHONE: {
    title: "Verifica tu celular",
    message: "Enviamos un código a tu celular por favor ingresa el código recibido"
  }
};

// `titulo` y `mensaje` (opcionales) reemplazan los textos de siempre: p. ej. "Confirma tu celular" y a qué número se mandó el código
const CodeModal = ({ 
  show, changeCode, validateCode, cancel, type, titulo, mensaje
}) => {
  // Las casillas del PIN no son de MUI: su estilo lleva los valores del tema
  const { palette } = useTheme();
  return (
    <Modal
      disablePortal
      disableEnforceFocus
      disableAutoFocus
      open={show}
      aria-labelledby="server-modal-title"
      aria-describedby="server-modal-description"
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          // En el celular el 70% con 80px de relleno dejaba las cajitas del código una debajo de otra
          width: { xs: "calc(100% - 32px)", sm: "70%" },
          bgcolor: "background.paper",
          boxShadow: 24,
          maxWidth: "sm",
          p: { xs: 3, sm: 10 },
          boxSizing: "border-box",
        }}
      >
        <Typography color="primary" mb={3} mt={3} variant="h4" component="h5" sx={{ textAlign: "center", fontSize: { xs: "1.75rem", sm: "2.125rem" } }}>
          {titulo || DEFAULT_TYPE[type].title}
        </Typography>
        <Typography variant="body1" mb={3} sx={{ textAlign: "center" }}>
          {mensaje || DEFAULT_TYPE[type].message}
        </Typography>
        <PinInput
          length={4}
          onChange={(value) => changeCode(value)} 
          inputStyle={{
            marginRight: "7px", 
            borderRadius: "8px", 
            borderColor: palette.primary.main
          }}
          inputFocusStyle={{borderColor: palette.secondary.main}}
        />
        <Button
          sx={{ marginTop: 3, marginBottom: 3}}
          onClick={validateCode}
          variant="contained"
          color="primary"
        >
          Validar código
        </Button>
        <Button  onClick={cancel}>
          Cancelar
        </Button>
      </Box>
    </Modal>
  );
}

export default CodeModal;
